import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a38df513"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-fb-shell" }
const _hoisted_2 = {
  ref: "fxCanvas",
  class: "nge-fb-fx",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  key: 0,
  class: "nge-fb-sending",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-fb-sending-title" }, "Sending your report", -1 /* HOISTED */))
const _hoisted_5 = { class: "nge-fb-steps" }
const _hoisted_6 = {
  class: "nge-fb-step-mark",
  "aria-hidden": "true"
}
const _hoisted_7 = {
  key: 1,
  class: "nge-fb-body"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-fb-title" }, "Submit an issue", -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-fb-hint" }, "Found a bug or have an idea? Tell us, it goes straight to the team.", -1 /* HOISTED */))
const _hoisted_10 = {
  key: 0,
  class: "nge-fb-update",
  role: "status"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "A newer version of Pyr is out. Reload first: what you are seeing may already be fixed.", -1 /* HOISTED */))
const _hoisted_12 = { class: "nge-fb-chips" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["maxlength"]
const _hoisted_15 = { class: "nge-fb-attach" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Attach my current view, a share link so the team sees exactly what I see", -1 /* HOISTED */))
const _hoisted_17 = ["checked", "disabled"]
const _hoisted_18 = { class: "nge-fb-shot-row" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "14",
  height: "14",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3 8h3l2-2.5h8L18 8h3v11H3z" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "13.5",
    r: "3.8"
  })
], -1 /* HOISTED */))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Screenshot", -1 /* HOISTED */))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "nge-fb-shot-preview"
}
const _hoisted_24 = ["href"]
const _hoisted_25 = ["src"]
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 4,
  class: "nge-fb-err"
}
const _hoisted_28 = { class: "nge-fb-actions" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "holoscan-line",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-fb-corner nge-fb-corner--tl",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-fb-corner nge-fb-corner--br",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-fb-seal",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 96 96" }, [
    /*#__PURE__*/_createElementVNode("circle", {
      class: "nge-fb-seal-ticks",
      cx: "48",
      cy: "48",
      r: "44"
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      class: "nge-fb-seal-arc",
      cx: "48",
      cy: "48",
      r: "37"
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      class: "nge-fb-seal-ring",
      cx: "48",
      cy: "48",
      r: "29",
      pathLength: "100"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      class: "nge-fb-seal-check",
      pathLength: "100",
      d: "M34 49.5 44 59 63 38.5"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-fb-seal-wave" }),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-fb-seal-wave nge-fb-seal-wave--2" })
], -1 /* HOISTED */))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-fb-done-kicker" }, "Signal received", -1 /* HOISTED */))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-fb-done-text" }, "Thank you! Your report reached the team.", -1 /* HOISTED */))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-fb-done-next" }, "We'll look into it!", -1 /* HOISTED */))
const _hoisted_37 = { class: "nge-fb-readout" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["ModalOverlay"], {
    id: "nge-feedback-modal",
    class: "nge-feedback-modal",
    onHide: _cache[20] || (_cache[20] = $event => ($setup.emit('hide')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("canvas", _hoisted_2, null, 512 /* NEED_PATCH */),
        _createElementVNode("button", {
          class: "nge-fb-exit",
          onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('hide')))
        }, "×"),
        _createCommentVNode(" The same capture + annotate + upload dialog the help request form\n           uses. Teleported to <body>: .nge-overlay-content has a\n           backdrop-filter, which would otherwise become the containing block\n           for the dialog's position: fixed overlay and clip it to the modal. "),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          _createVNode($setup["ScreenshotDialog"], {
            show: $setup.showScreenshotDialog,
            mode: "attach",
            onClose: _cache[1] || (_cache[1] = $event => ($setup.showScreenshotDialog = false)),
            onAttached: $setup.onScreenshotAttached
          }, null, 8 /* PROPS */, ["show"])
        ])),
        ($setup.sending && !$setup.done)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode($setup["GrowingNeuron"], {
                stage: $setup.stepsDone,
                stages: $setup.sendSteps.length,
                seed: $setup.neuronSeed
              }, null, 8 /* PROPS */, ["stage", "stages", "seed"]),
              _hoisted_4,
              _createElementVNode("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sendSteps, (st) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: st.key,
                    class: _normalizeClass(["nge-fb-step", `nge-fb-step--${$setup.stepState(st.key)}`])
                  }, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString($setup.stepState(st.key) === 'done' ? '✓' : ''), 1 /* TEXT */),
                    _createElementVNode("span", null, _toDisplayString(st.label), 1 /* TEXT */)
                  ], 2 /* CLASS */))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          : (!$setup.done)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _hoisted_9,
                _createCommentVNode(" Behind the live version: the bug may already be fixed (Ames 2026-10-07). "),
                ($setup.version.newer)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("button", {
                        type: "button",
                        class: "nge-fb-update-btn",
                        onClick: _cache[2] || (_cache[2] = $event => ($setup.reloadForUpdate()))
                      }, "Reload now")
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.CATEGORIES, (c) => {
                    return _createElementVNode("button", {
                      key: c,
                      class: _normalizeClass(["nge-fb-chip", { 'nge-fb-chip--active': $setup.category === c }]),
                      onClick: $event => {$setup.category = c; $setup.error = ''}
                    }, _toDisplayString(c), 11 /* TEXT, CLASS, PROPS */, _hoisted_13)
                  }), 64 /* STABLE_FRAGMENT */))
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.title) = $event)),
                  class: "nge-fb-note nge-fb-headline",
                  maxlength: $setup.TITLE_MAX,
                  placeholder: "In a few words, what is it?",
                  "aria-label": "In a few words, what is it?",
                  onKeydown: [
                    _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                    _cache[7] || (_cache[7] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                  ],
                  onKeyup: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                  onKeypress: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
                  onInput: _cache[8] || (_cache[8] = $event => ($setup.error = ''))
                }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                  [_vModelText, $setup.title]
                ]),
                (!$setup.detailsOpen)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "nge-fb-more",
                      onClick: _cache[9] || (_cache[9] = $event => ($setup.detailsOpen = true))
                    }, "+ Add details (optional)"))
                  : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                      key: 2,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($setup.message) = $event)),
                      class: "nge-fb-note",
                      rows: "3",
                      placeholder: "Anything else that helps, like what you expected.",
                      "aria-label": "Details",
                      maxlength: $setup.detailsMax,
                      onKeydown: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
                      onKeyup: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"])),
                      onKeypress: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"])),
                      onInput: _cache[14] || (_cache[14] = $event => ($setup.error = ''))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_14)), [
                      [_vModelText, $setup.message]
                    ]),
                ($setup.detailsOpen)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: _normalizeClass(["nge-fb-count", { 'nge-fb-count--full': $setup.message.length >= $setup.detailsMax }])
                    }, [
                      _createElementVNode("span", null, _toDisplayString($setup.message.length) + " / " + _toDisplayString($setup.detailsMax), 1 /* TEXT */),
                      (!$setup.detailsLong && $setup.message.length >= $setup.DETAILS_SHORT - 50)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "nge-fb-more nge-fb-more--inline",
                            onClick: _cache[15] || (_cache[15] = $event => ($setup.detailsLong = true))
                          }, "I need to add more"))
                        : _createCommentVNode("v-if", true)
                    ], 2 /* CLASS */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("label", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => (($setup.attachView) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelCheckbox, $setup.attachView]
                  ]),
                  _hoisted_16
                ]),
                _createCommentVNode(" With nothing to attach the box is greyed out and empty (Ames\n             2026-10-19: it showed ticked, as if something would be sent). "),
                _createElementVNode("label", {
                  class: _normalizeClass(["nge-fb-attach", { 'nge-fb-attach--off': !$setup.consoleCount }])
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: $setup.attachConsole && !!$setup.consoleCount,
                    disabled: !$setup.consoleCount,
                    onChange: $setup.onConsoleToggle
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_17),
                  _createElementVNode("span", null, [
                    _createTextVNode("Attach recent console messages"),
                    ($setup.consoleCount)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" (" + _toDisplayString($setup.consoleCount) + " recent warnings and errors, passwords and tokens removed)", 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" (none so far)")
                        ], 64 /* STABLE_FRAGMENT */))
                  ])
                ], 2 /* CLASS */),
                _createElementVNode("div", _hoisted_18, [
                  (!$setup.screenshotUrl)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "nge-fb-chip nge-fb-shot-btn",
                        disabled: $setup.sending,
                        title: "Capture the current view and mark it up with the pen",
                        onClick: _cache[17] || (_cache[17] = $event => ($setup.showScreenshotDialog = true))
                      }, _hoisted_22, 8 /* PROPS */, _hoisted_19))
                    : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("a", {
                          href: $setup.screenshotUrl,
                          target: "_blank",
                          rel: "noopener",
                          title: "Open full size"
                        }, [
                          _createElementVNode("img", {
                            src: $setup.screenshotUrl,
                            alt: "Attached screenshot"
                          }, null, 8 /* PROPS */, _hoisted_25)
                        ], 8 /* PROPS */, _hoisted_24),
                        _createElementVNode("button", {
                          class: "nge-fb-shot-remove",
                          disabled: $setup.sending,
                          title: "Remove screenshot",
                          "aria-label": "Remove screenshot",
                          onClick: $setup.clearScreenshot
                        }, "×", 8 /* PROPS */, _hoisted_26)
                      ]))
                ]),
                ($setup.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString($setup.error), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("button", {
                    class: "nge-fb-submit",
                    disabled: $setup.sending,
                    onClick: $setup.submit
                  }, _toDisplayString($setup.sending ? 'Sending…' : 'Submit'), 9 /* TEXT, PROPS */, _hoisted_29),
                  _createElementVNode("button", {
                    class: "nge-fb-cancel",
                    onClick: _cache[18] || (_cache[18] = $event => ($setup.emit('hide')))
                  }, "Cancel")
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "nge-fb-done holoscan holo-on",
                role: "status",
                "aria-live": "polite",
                onClick: _cache[19] || (_cache[19] = $event => ($setup.emit('hide')))
              }, [
                _hoisted_30,
                _hoisted_31,
                _hoisted_32,
                _createCommentVNode(" The same neuron, now lit end to end: the signal arrived. "),
                _createVNode($setup["GrowingNeuron"], {
                  arrived: "",
                  seed: $setup.neuronSeed
                }, null, 8 /* PROPS */, ["seed"]),
                _hoisted_33,
                _hoisted_34,
                _hoisted_35,
                _hoisted_36,
                _createElementVNode("dl", _hoisted_37, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sentWith, (x, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: x.k,
                      class: "nge-fb-readout-cell",
                      style: _normalizeStyle({ '--i': i })
                    }, [
                      _createElementVNode("dt", null, _toDisplayString(x.k), 1 /* TEXT */),
                      _createElementVNode("dd", null, _toDisplayString(x.v), 1 /* TEXT */)
                    ], 4 /* STYLE */))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]))
      ])
    ]),
    _: 1 /* STABLE */
  }))
}